import {Component, Input} from '@angular/core';
import {League, Lookups} from "@model";

@Component({
  selector: 'app-league-event-list-tab',
  templateUrl: './league-event-list-tab.component.html',
  styleUrls: ['./league-event-list-tab.component.scss']
})
export class LeagueEventListTabComponent {

  @Input() league: League | undefined;
  @Input() countries: Lookups[] = [];
  @Input({required: true}) languages: Lookups[] = [];
}
